import { DropDownList, TextBox } from "@repo/ui";
import { useMemo } from "react";

import type { SettingEnumOption } from "../../../models";

interface Props {
	/** The placeholder, such as [CarrierType] */
	label: string;
	/** The enum values whose names are allowed in its place; empty when any text will do */
	options: SettingEnumOption[];
	value: string;
	onChange: (value: string) => void;
}

/** Fills in a [Placeholder] in a setting's name: a dropdown of its enum's values, or a text box when it has no enum */
export function PlaceholderInput({ label, options, value, onChange }: Props) {
	// The code reads the name from the setting's name, so the name fills the placeholder; the label is only shown
	const names = useMemo(() => options.map((o) => ({ value: o.name, label: o.label })), [options]);

	if (names.length)
		return (
			<DropDownList
				label={label}
				values={names}
				value={value || null}
				fullLength
				changeHandler={(selected: string) => onChange(selected ?? "")}
			/>
		);

	return <TextBox label={label} value={value} changeHandler={(entered) => onChange(entered ?? "")} />;
}
